import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const activityUrl = `${SERVER_API}/catalogs/activities`;
